import styled from "@emotion/styled";
import { useTheme } from "@mui/material";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledMetadataSkeleton = styled("div")(({ theme }) => ({
    paddingTop: theme.spacing(1),
    maxWidth: "80%",
}));

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    marginTop: theme.spacing(2),
}));

const StyledWrapper = styled("div")(({ theme }) => ({
    paddingTop: theme.spacing(1),
    display: "flex",
}));

const StyledInnerWrapper = styled("div")(({ theme }) => ({
    marginLeft: theme.spacing(2),
    width: "100%",
}));

/**
 * media page metadata skeleton
 */
export function MetadataSkeleton() {
    const theme = useTheme();

    return (
        <StyledMetadataSkeleton>
            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"100%"} />

            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"60%"} />

            <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"80%"} />

            <StyledWrapper>
                <StyledSkeleton variant="rectangular" height={theme.spacing(6)} width={theme.spacing(6)} />

                <StyledInnerWrapper>
                    <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"20%"} />

                    <StyledSkeleton variant="rectangular" height={theme.spacing(2)} width={"10%"} />
                </StyledInnerWrapper>
            </StyledWrapper>
        </StyledMetadataSkeleton>
    );
}

export default MetadataSkeleton;
